import { useTranslation } from "react-i18next";
import { usePagination } from "datastake-daf/dist/hooks";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { getFiltersConfig } from "../config";
import modules from "../../../../components/ModuleLoader/modules";
import { useUserRoles } from "../../../../components/Forms/users/config";
import TableFilters from "../../../../components/Forms/projects/tableFilters";

export const useSection = ({
  total = 0,
  perPage = 0,
  countries = [],
  _options = {},
  _setPage,
  activeFilters = {},
  setActiveFilters = () => { },
  search = '',
  setSearch = () => { },
  applications=[],
}) => {
  const loadingKeys = useRef({});
  const [toggledKeys, setToggledKeys] = useState([]);
  const [expandedRows, setExpandedRows] = useState([]);
  const userRoles = useUserRoles();
  const { t } = useTranslation();
  const {
    goPrev,
    goNext,
    canGoPrev,
    page,
    setPage,
  } = usePagination({ total, perPage });

  const options = useMemo(() => ({ countries, ..._options }), [countries, _options]);

  const filtersInit = useMemo(() =>
    getFiltersConfig({ t, userRoles, modules, options, activeFilters, applications }), [t, userRoles, options, activeFilters, applications]);

  useEffect(() => {
    _setPage(page);
  }, [page]);

  const canGoNext = useMemo(() => {
    if (total === 0) {
      return false;
    }

    const pages = Math.ceil(total / perPage);
    if (page !== pages) {
      return true;
    }

    return false;
  }, [page, total, perPage]);

  const renderFilters = () => (
    <div className="table-filters">
      <TableFilters
        className="widget-filters pb-0"
        activeFiltersInit={activeFilters}
        injectCountry={false}
        setActiveFilters={(props) => {
          setActiveFilters(props);
          setPage(1);
        }}
        t={t}
        search={search}
        setSearch={(props) => {
          setSearch(props);
          setPage(1);
        }}
        filtersInit={filtersInit}
      />
    </div>
  )

  return {
    renderFilters,
    loadingKeys,
    toggledKeys,
    setToggledKeys,
    expandedRows,
    setExpandedRows,
    userRoles,
    t,
    goPrev,
    goNext,
    canGoPrev,
    page,
    setPage,
    canGoNext,
    options,
  }
}
